import React from 'react';

import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import PropTypes from 'prop-types';

import {
  TextField,
  DateField,
  IntegerField,
  LookupField
} from 'react/components/fields';
import { getResourceTo } from 'react/utils/utils';

function IntegrationFormSection({ title }) {
  return (
    <FormSection title={getResourceTo(title)} className="generalSection">
      <FormSectionColumn>
        <IntegerField
          label={getResourceTo('integrationLog.field.status')}
          name="httpStatus"
        />
        <TextField
          label={getResourceTo('integrationLog.field.key')}
          name="key"
        />
        <TextField
          label={getResourceTo('integrationLog.field.entityDescription')}
          name="description"
        />
        <LookupField
          label={getResourceTo('integrationLog.field.organization')}
          name="organization"
          lookupEntity="Organization"
          lookupEntityColumn="description"
        />
        <DateField
          label={getResourceTo('integrationLog.field.date')}
          name="requestDate"
          type="DATE_TIME"
        />
        <TextField
          label={getResourceTo('integrationLog.field.responseMessage')}
          name="message"
        />
      </FormSectionColumn>
    </FormSection>
  );
}

IntegrationFormSection.propTypes = {
  title: PropTypes.string.isRequired
};

export default IntegrationFormSection;
